<template>
  <div>
    <vxe-grid
      ref="table"
      size="mini"
      row-id="amzPurchaseDetailCode"
      resizable
      auto-resize
      :show-footer="showFooter"
      highlight-hover-row
      :data="tableData"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :footer-method="() => footerData"
      :seq-config="{ seqMethod }"
      :cell-class-name="cellClassName"
      :edit-config="{ trigger: 'manual', mode: 'row', enabled: !disabled }"
      :edit-rules="editRules"
      @edit-actived="editActived"
      @edit-closed="editClosed"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:opt="{ row, rowIndex }">
        <div class="m-0" v-if="!row.isChange && !row.isNew && !disabled">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_tips_change') || '编辑'"
            placement="left"
          >
            <i
              class="el-icon-edit-outline tool-btn"
              @click="changeRow(row, rowIndex)"
            />
          </el-tooltip>
          <br />
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_delete') || '删除'"
            placement="left"
          >
            <i class="el-icon-delete tool-btn" @click="delChange(row)"></i>
          </el-tooltip>
        </div>
        <div
          class="m-0"
          v-if="row.isChange && !row.isNew && !!row.changeType && !disabled"
        >
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_rollbackChange') || '取消变更'"
            placement="left"
          >
            <i
              class="el-icon-refresh-left tool-btn"
              @click="rollbackChange(row)"
            ></i>
          </el-tooltip>
        </div>
        <div class="m-0" v-if="!row.isChange && row.isNew">
          <el-tooltip
            v-if="!row.isActiveRow && row.changeType == 'U' && !disabled"
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="left"
          >
            <i class="el-icon-edit tool-btn" @click="activeRow(row)" />
          </el-tooltip>
          <el-tooltip
            v-if="row.isActiveRow && !disabled"
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_cancel') || '取消'"
            placement="left"
          >
            <i class="el-icon-close tool-btn" @click="cancelActive(row)" />
          </el-tooltip>
          <el-tooltip
            v-if="!!row.changeType"
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_view_details') || '查看详情'"
            placement="top"
          >
            <i class="el-icon-view tool-btn" @click="changeDetail(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template
        v-slot:defaultImageUrl="{ row: { defaultImageUrl, isNew, changeType } }"
      >
        <div class="m-0" v-if="isNew">
          <!-- A-添加 U-修改 D-删除 -->
          <el-tag
            size="mini"
            :type="
              changeType == 'D' ? 'danger' : changeType == 'A' ? 'success' : ''
            "
          >
            {{
              changeType == 'D' ? '删除' : changeType == 'A' ? '新增' : '修改'
            }}
          </el-tag>
        </div>
        <el-image
          v-else-if="defaultImageUrl"
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width:100%;"
        >
          <div slot="error" class="image-slot">
            <img src="/image/static/img/nopic.jpg" style="width:100%;" />
          </div>
        </el-image>
      </template>
      <template v-slot:displayNo="{ row }">
        <div class="m-0" v-if="!row.isNew">
          <div v-if="row.ncNo">
            <span class="mr-1">NC:</span>
            <span>{{ row.ncNo }}</span>
          </div>
          <div v-if="row.amzSkuNo">
            <span class="mr-1">SKU:</span>
            <span>{{ row.amzSkuNo }}</span>
          </div>
          <div v-if="row.eanCode">
            <span class="mr-1">UPC:</span>
            <span>{{ row.eanCode }}</span>
          </div>
        </div>
      </template>
      <template v-slot:displayName="{ row }">
        <div class="m-0">
          <div>{{ row.goodsName }}</div>
          <div>{{ row.goodsNameEn }}</div>
          <div v-if="row.goodsSize">
            <span class="mr-1">SIZE:</span>
            <span>{{ row.goodsSize }}</span>
          </div>
          <div v-if="row.goodsColor || row.goodsColorEn">
            <span class="mr-1">COLOR:</span>
            <span>{{ row.goodsColor }}{{ row.goodsColorEn }}</span>
          </div>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import {
  format,
  add,
  multiply,
  divide,
  divideRound,
} from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    showFooter: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (n) => format(n),
      currActivedRow: {},
      editRules: {
        inCtnQty: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        purchaseQty: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
          {
            validator: ({ row }) => {
              const {
                inCtnQty,
                purchaseQty,
                shippedQty,
                shortageQuantity = 0,
              } = row
              const ctnQty = divideRound(purchaseQty, inCtnQty, 0)
              const submitQty = multiply(inCtnQty, ctnQty)
              if (submitQty !== purchaseQty) {
                return new Error('采购数量不满整箱')
              }

              if (shippedQty > purchaseQty - shortageQuantity) {
                return new Error('采购数量-短装数量小于已出货数量')
              }
            },
          },
        ],
        purchasePrice: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
      },
    }
  },
  computed: {
    tableColumns() {
      return tableColumns(this)
    },
    footerData() {
      return [this.totalBeforeChange, this.totalAfterChange]
    },
    totalBeforeChange() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.tableData
        .filter((c) => !c.isNew)
        .reduce((result, next) => {
          totalColumnFields.forEach((f) => {
            result[f] = add(result[f], next[f])
          })
          return result
        }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => {
          if (!t.isTotalColumn) return ''
          const val = totalColumnValues[t.field]
          return val ? format(val) : '0'
        })
      result[2] = this.$l('table_label_totalBeforeChange') || '变更前合计'
      return result
    },
    totalAfterChange() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.tableData
        .filter((r) => {
          const { isChange, isNew, changeType } = r
          if (isChange) return false
          return !isNew ? true : ['A', 'U'].includes(changeType)
        })
        .reduce((result, next) => {
          totalColumnFields.forEach((f) => {
            result[f] = add(result[f], next[f])
          })
          return result
        }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => {
          if (!t.isTotalColumn) return ''
          const val = totalColumnValues[t.field]
          return val ? format(val) : '0'
        })

      result[2] = this.$l('table_label_totalAfterChange') || '变更后合计'
      return result
    },
    tableEditColumns() {
      return this.tableColumns.filter((c) => !!c.editRender) || []
    },
    tableEditFields() {
      return this.tableEditColumns?.map((c) => c.field) || []
    },
    enableEdit() {
      return !!this.tableEditFields?.length
    },
  },
  watch: {
    disabled() {
      this.$refs.table.reloadColumn(this.tableColumns)
    },
  },
  methods: {
    seqMethod({ row }) {
      const { amzPurchaseDetailCode, isNew } = row
      if (isNew) return ''
      return (
        this.tableData
          .filter((item) => !item.isNew)
          .map((item) => item.amzPurchaseDetailCode)
          .indexOf(amzPurchaseDetailCode) + 1
      )
    },
    cellClassName({ row, column }) {
      const { property } = column
      if (property === 'defaultImageUrl' && row.isNew) {
        return 'align-center'
      }
      return 'align-top'
    },
    getRowById(rowid) {
      return this.$refs.table.getRowById(rowid)
    },
    editActived({ row }) {
      if (row.isActiveRow) return
      row.isActiveRow = true
      this.currActivedRow = { ...row }
    },
    async changeRow(row, rowIndex) {
      if (!row || !this.enableEdit) return

      const $table = this.$refs.table
      const {
        isNew = false,
        isChange = false,
        amzPurchaseDetailCode,
        inCtnQty,
        purchaseQty,
        ctnQty,
        purchasePrice,
        subAmount,
        actualDeliveryDate,
        shippedQty,
        shortageQuantity = 0,
        invQty,
      } = row

      if (isChange || isNew) return

      const newRow = {
        amzPurchaseDetailCode,
        inCtnQty,
        purchaseQty,
        ctnQty,
        purchasePrice,
        subAmount,
        actualDeliveryDate,
        shippedQty,
        shortageQuantity,
        invQty,
        isNew: true,
        originRow: row,
      }

      row.isChange = true

      // 判断是否是最后一行
      const { tableData } = $table.getTableData() || {}
      const rowCount = tableData?.length || 0

      const { row: insertRow } = await $table.insertAt(
        newRow,
        rowCount == rowIndex + 1 ? -1 : rowIndex + 1
      )
      $table.setActiveCell(insertRow, 'purchaseQty')
    },
    async activeRow(row) {
      if (!row || !this.enableEdit) return

      const { isNew = false, isChange = false, changeType } = row
      if (isChange || !isNew || (changeType || 'U') !== 'U') return

      const $table = this.$refs.table
      $table.setActiveCell(row, 'purchaseQty')
    },
    async cancelActive(row) {
      row.isActiveRow = false
      const $table = this.$refs.table

      this.tableEditFields.forEach((c) => {
        row[c] = this.currActivedRow[c]
      })

      setTimeout(async () => {
        await $table.clearValidate()
        $table.updateFooter()
        $table.clearAll()
      }, 0)
    },
    async editClosed({ row }) {
      if (!this.enableEdit) return

      const $table = this.$refs.table
      const result = !(await $table.validate(row))
      if (!result) return

      const { originRow, oldRow, ...currRow } = row

      const { amzPurchaseChangeCode, amzPurchaseDetailCode } = originRow
      const { purchasePrice, purchaseQty, inCtnQty, changeType } = currRow
      row.subAmount = multiply(purchasePrice, purchaseQty)
      row.ctnQty = divide(purchaseQty, inCtnQty)

      if (oldRow) {
        const currIsChange = this.tableEditFields.some((key) => {
          return oldRow[key] !== currRow[key]
        })
        if (!currIsChange) {
          this.$emit('reload')
          return
        }
      }

      if (this.loadingOpen()) return

      const changeFields = this.tableEditFields
        .map((field) => {
          const fieldOldValue = originRow[field]
          const fieldNewValue = currRow[field]
          if (fieldOldValue == fieldNewValue) return null
          return { fieldName: field, fieldOldValue, fieldNewValue, remark: '' }
        })
        .filter(Boolean)

      if (!changeType && !changeFields?.length) {
        $table.remove(row)
        const changeRow = this.getRowById(amzPurchaseDetailCode)
        changeRow.isChange = false
        this.loadingClose()
        return
      }

      if (!changeFields?.length) {
        const res = await this.$api
          .ecomAmzFtyPurchaseDetailChangeApi({
            fields: changeFields,
            amzPurchaseChangeCode,
            amzPurchaseDetailCode,
          })
          .catch(() => null)
        this.loadingClose()
        const { status, msg } = res || {}
        if (status == 200) {
          this.$message({ showClose: true, message: msg, type: 'success' })
        }
        this.$emit('reload')
        return
      }

      this.$emit('change-detail', {
        amzPurchaseDetailCode,
        changeType: 'U',
        changeFields,
        optType: 'edit',
      })
      setTimeout(() => {
        this.loadingClose()
      }, 100)
    },
    async delChange(row) {
      const { isNew = false, isChange = false, amzPurchaseDetailCode, shippedQty } = row
      if (isChange || isNew) return
      
      if (shippedQty) {
        this.$message({
          message: this.$l('tips_delChange_shippedWarning') || '该产品已出过货了，无法删除',
          type: 'warning',
        })
        return
      }

      this.$emit('change-detail', {
        amzPurchaseDetailCode,
        changeType: 'D',
        optType: 'edit',
      })
    },
    async rollbackChange(row) {
      const {
        isNew = false,
        isChange = false,
        amzPurchaseChangeCode,
        amzPurchaseDetailCode,
      } = row
      if (!isChange || isNew) return

      const confirm = await this.$confirm(
        this.$l('tips_rollbackChange') || '是否要取消该产品的变更？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)

      if (!confirm) return
      if (this.loadingOpen()) return

      const params = { amzPurchaseChangeCode, amzPurchaseDetailCode }
      const res = await this.$api
        .ecomAmzFtyPurchaseDetailChangeRollbackApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_rollbackChange_no') || '取消失败！')
        return
      }
      this.$message({
        message: this.$l('tips_rollbackChange_ok') || '取消成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    changeDetail(row) {
      const { changeType, isChange, isNew } = row
      if (!changeType || isChange || !isNew) return
      this.$emit('change-detail', row)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-cell {
    > div {
      margin-top: 7px;
    }
  }
  .vxe-table--render-default .vxe-body--row:first-child .vxe-cell--valid {
    top: initial;
    padding-top: 4px;
  }
  .col-opt {
    padding-top: 0 !important;
  }
  .col--seq {
    padding-top: 11px !important;
  }
}
</style>
